var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navbar"}},[_c('ul',[_c('li',{attrs:{"id":"title"}},[_vm._v(" Tony Dinh ")]),_vm._l((_vm.links),function(routes){return _c('router-link',{key:routes.id,staticClass:"links",attrs:{"tag":"li","active-class":"active","to":`${routes.page}`}},[_vm._v("\n          "+_vm._s(routes.text)+"\n      ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }